import React from "react";

// Locked flat TASTE TEST brand wordmark (V0.2C Run 4). The approved FLAT assets
// are authoritative — TASTE in bone, TEST with signal-red leading T + signal-blue
// trailing T, distinctive angular terminal. Rendered from the transparent PNG/WEBP
// masters so the mark is pixel-faithful on the near-black canvas. Size via a height
// utility on className (e.g. `h-4`, `h-24`); width stays auto.

const SRC = {
  horizontal: "/tt-wordmark-a.webp", // TASTE TEST on one line (~3:1)
  stacked: "/tt-wordmark-b.png",     // TASTE over TEST (square-ish)
};

export default function Wordmark({ variant = "horizontal", className = "", style, alt = "TASTE TEST" }) {
  return (
    <img
      src={SRC[variant] || SRC.horizontal}
      alt={alt}
      draggable={false}
      className={`w-auto select-none ${className}`}
      style={style}
      data-testid="brand-wordmark"
    />
  );
}
